import { motion } from "framer-motion";
import GoldButton from "./GoldButton";

export default function Finale() {
  return (
    <section
      id="finale"
      data-testid="finale-section"
      className="relative z-10 overflow-hidden px-6 py-32 text-center md:py-48"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2">
        <div
          className="h-full w-full animate-[spin_28s_linear_infinite] rounded-full opacity-30 blur-3xl"
          style={{
            background:
              "conic-gradient(from 0deg, transparent 0deg, rgba(212,175,55,0.5) 60deg, transparent 120deg, rgba(212,175,55,0.3) 200deg, transparent 300deg)",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-5xl">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mb-10 text-[11px] tracking-[0.55em] text-[#BDBDB6] md:text-sm"
        >
          DAS FINALE · ALLES FÜHRT ZURÜCK
        </motion.p>

        <div className="overflow-hidden">
          <motion.div
            initial={{ y: "112%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-20%" }}
            transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
            className="gold-text font-serif-accent text-[24vw] leading-none md:text-[11rem]"
            data-testid="finale-monogram"
          >
            S&F
          </motion.div>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ delay: 0.3, duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
        >
          Bereit für eine Website aus Augsburg, die{" "}
          <em className="gold-text font-serif-accent normal-case italic">Eindruck</em> hinterlässt?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mx-auto mt-8 max-w-xl text-base font-light leading-relaxed text-[#BDBDB6] md:text-lg"
        >
          Wir entwickeln digitale Erlebnisse, die Ihre Marke sichtbar machen und Kunden
          überzeugen.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.7, duration: 1 }}
          className="mt-12"
        >
          <GoldButton href="#kontakt" testId="finale-cta-button" className="px-12 py-5 text-lg">
            Kostenlose Erstberatung
          </GoldButton>
        </motion.div>
      </div>
    </section>
  );
}
